const UserPaths = {
  regular: 0,
  lab: 1,
  clinic: 2
}

//Vue.use(Vuex) // (i) You don't need to do this when using global script tags.

const vStore = new Vuex.Store({
  state: {
    userPath: 0,
    pageIsLoading: false,
    isMobile: false
  },
  getters: {
    userPath: state => state.userPath,
    pageIsLoading: state => state.pageIsLoading,
    isMobile: state => state.isMobile,
  },
  mutations: {
    setUserPath(state, data){
      state.userPath = data
    },

    setPageIsLoading(state, data){
      state.pageIsLoading = data
    },

    setIsMobile(state, data){
      state.isMobile = data
    }

  },
  actions: {
    sayHi(){
      appLog.log('HIIIIII index')
    },

    setPageIsLoading({commit}, boolValue){
      commit('setPageIsLoading', boolValue)
    },

    scrollToTop(){
      window.scrollTo({
          top: 0,
          left: 0, 
          behavior: 'smooth'
      })
    },

    toSnakeLowerCaseValidSelector({},text) {
      // Replace spaces with underscores
      const selector = text.replace(/\s/g, '_')
    
      // Remove special characters and make it valid
      const validSelector = selector.replace(/[^a-zA-Z0-9-_]/g, '')
    
      return validSelector.toLowerCase()
    },

    setUserPathToRegular({commit}){
      commit('setUserPath', UserPaths.regular)
    },
    setUserPathToLab({commit}){
      commit('setUserPath', UserPaths.lab)
    },
    setUserPathToClinic({commit}){
      commit('setUserPath', UserPaths.clinic)
    },

    setStoreIsMobile({commit}, isMobile){
      commit('setIsMobile', isMobile)
    },


  },
  // modules: {
  //   navBar: ,
  // }
})